{
  "en": {
    "hero": {
      "title": "A hypnosis session written for you, for how you feel now.",
      "line": "Quies is AI hypnosis you can start right now. Choose how you feel, and a calm voice reads your session to you.",
      "cta": "Start a session"
    },
    "mailHeadline": "A session written for you, for how you feel now",
    "tags": {
      "listen": "Listen"
    },
    "written": {
      "title": "Written for this moment",
      "body": "Tell us how you feel in a few taps or a few words. Your session is written for that moment, then read to you."
    },
    "listen": {
      "title": "Listen to one",
      "body": "Each session is spoken in a calm voice. The words it speaks are printed under the player."
    },
    "tongues": {
      "title": "In your language",
      "body": "Sessions are also written in other languages. Play one here, in the language you feel most at ease in."
    },
    "remembers": {
      "title": "It remembers you",
      "body": "Your next session starts where the last one stopped. Quies keeps a few things in mind from one session to the next.",
      "lines": [
        "How you felt last time.",
        "What helped you relax.",
        "Where you stopped listening."
      ]
    },
    "methods": {
      "title": "The methods",
      "body": "Quies draws on six well-known methods of rest and calm.",
      "items": {
        "ericksonian": {
          "label": "Ericksonian hypnosis",
          "desc": "A gentle, indirect style of hypnosis that speaks in soft, open suggestions."
        },
        "autogenic": {
          "label": "Autogenic training",
          "desc": "Calm the body through simple phrases about warmth and heaviness in the arms and legs."
        },
        "pmr": {
          "label": "Progressive muscle relaxation",
          "desc": "Tense one muscle group at a time, then let it go, until the body feels loose."
        },
        "nidra": {
          "label": "Yoga nidra",
          "desc": "A practice of lying still while a calm voice guides attention through the body."
        },
        "nsdr": {
          "label": "NSDR",
          "desc": "Non-sleep deep rest: lie still and let the mind settle, without falling asleep."
        },
        "sophrology": {
          "label": "Sophrology",
          "desc": "Simple breathing and body movements that bring calm and clear focus to the moment."
        }
      }
    },
    "closing": {
      "title": "Your first session is free",
      "body": "Your first session costs nothing, and no card is needed. Listening again to a past session is always free. Paid plans exist if you want more.",
      "cta": "Start a session"
    },
    "plans": {
      "heading": "More sessions",
      "body": "If you want more sessions, a paid plan gives you room for them."
    }
  },
  "fr": {
    "hero": {
      "title": "Une séance d'hypnose écrite pour vous",
      "line": "Quies vous propose une hypnose par IA que vous pouvez lancer dès maintenant. Dites-nous ce que vous ressentez, et une voix calme vous lit la séance.",
      "cta": "Commencer une séance"
    },
    "mailHeadline": "Votre séance d'hypnose vous attend",
    "tags": {
      "listen": "Écouter"
    },
    "written": {
      "title": "Écrite pour ce moment",
      "body": "Dites en quelques touches ou quelques mots comment vous vous sentez. La séance est écrite pour ce moment, puis lue à voix haute."
    },
    "listen": {
      "title": "Écoutez une séance",
      "body": "Des séances réelles, avec le texte prononcé affiché sous le lecteur."
    },
    "tongues": {
      "title": "Dans votre langue",
      "body": "Des séances existent dans d'autres langues. Vous pouvez les écouter ici."
    },
    "remembers": {
      "title": "Il se souvient de vous",
      "body": "La séance suivante reprend là où la précédente s'est arrêtée.",
      "lines": [
        "Ce qui vous a apaisé récemment.",
        "Les moments où vous voulez vous détendre.",
        "Le ton et le rythme qui vous conviennent."
      ]
    },
    "methods": {
      "title": "Les méthodes utilisées",
      "body": "Quies s'appuie sur des méthodes de détente connues. Choisissez celle qui vous convient.",
      "items": {
        "ericksonian": {
          "label": "Hypnose ericksonienne",
          "desc": "Une hypnose douce, qui vous invite à vous laisser aller."
        },
        "autogenic": {
          "label": "Training autogène",
          "desc": "Une série d'exercices simples pour ressentir la chaleur et la lourdeur du corps."
        },
        "pmr": {
          "label": "Relaxation musculaire progressive",
          "desc": "Vous tendez puis relâchez chaque groupe de muscles, pour sentir la détente."
        },
        "nidra": {
          "label": "Yoga nidra",
          "desc": "Un état de repos guidé, allongé, où le corps se détend et l'esprit se calme."
        },
        "nsdr": {
          "label": "NSDR (repos profond sans sommeil)",
          "desc": "Une pause guidée, allongé, pour reposer l'esprit et le corps."
        },
        "sophrology": {
          "label": "Sophrologie",
          "desc": "Des exercices de respiration et de détente, pour se sentir plus calme au quotidien."
        }
      }
    },
    "closing": {
      "title": "Votre première séance est gratuite",
      "body": "Aucune carte bancaire n'est demandée. Réécouter une séance passée reste toujours gratuit. Des formules payantes existent si vous en voulez davantage.",
      "cta": "Commencer une séance"
    },
    "plans": {
      "heading": "Aller plus loin",
      "body": "Si vous voulez davantage de séances, des formules payantes vous ouvrent un accès plus large."
    }
  },
  "de": {
    "hero": {
      "title": "Eine Sitzung für Ihr Gefühl jetzt",
      "line": "Quies ist KI-Hypnose, die Sie sofort beginnen können. Sie sagen, wie Sie sich fühlen, und eine ruhige Stimme liest Ihnen die Sitzung vor.",
      "cta": "Sitzung beginnen"
    },
    "mailHeadline": "Ihre Sitzung für genau jetzt",
    "tags": {
      "listen": "Anhören"
    },
    "written": {
      "title": "Geschrieben für diesen Moment",
      "body": "Mit wenigen Fingertipps oder Worten sagen Sie uns, wie Sie sich gerade fühlen. Die Sitzung wird genau dafür geschrieben und dann vorgelesen."
    },
    "listen": {
      "title": "Eine Sitzung anhören",
      "body": "Hören Sie echte Sitzungen direkt an. Die gesprochenen Worte stehen unter dem Player, damit Sie mitlesen können."
    },
    "tongues": {
      "title": "In Ihrer Sprache",
      "body": "Sitzungen gibt es auch in weiteren Sprachen, und Sie können sie hier direkt abspielen."
    },
    "remembers": {
      "title": "Es erinnert sich an Sie",
      "body": "Die nächste Sitzung knüpft an die letzte an. Quies behält diese Punkte von einer zur nächsten im Blick.",
      "lines": [
        "Was Sie zuletzt beschäftigt hat.",
        "Wie Sie sich nach der letzten Sitzung fühlten.",
        "Wo die letzte Sitzung endete."
      ]
    },
    "methods": {
      "title": "Verschiedene Methoden",
      "body": "Wählen Sie eine Methode, die Ihnen zusagt. Jede Sitzung folgt ihrem eigenen Weg zur Ruhe.",
      "items": {
        "ericksonian": {
          "label": "Ericksonsche Hypnose",
          "desc": "Sanfte Hypnose, die Ihre eigenen Bilder und Gefühle einbezieht."
        },
        "autogenic": {
          "label": "Autogenes Training",
          "desc": "Schwere und Wärme im Körper spüren, Schritt für Schritt."
        },
        "pmr": {
          "label": "Progressive Muskelentspannung",
          "desc": "Muskeln nacheinander anspannen und lösen, bis der Körper locker wird."
        },
        "nidra": {
          "label": "Yoga Nidra",
          "desc": "Liegend durch den Körper wandern, bis der Geist ruhig wird."
        },
        "nsdr": {
          "label": "NSDR (Tiefenruhe ohne Schlaf)",
          "desc": "Eine kurze Pause, in der Sie wach bleiben und trotzdem ausruhen."
        },
        "sophrology": {
          "label": "Sophrologie",
          "desc": "Atmung, Körperübungen und Bilder, die Ihnen Gelassenheit geben."
        }
      }
    },
    "closing": {
      "title": "Die erste Sitzung ist kostenlos",
      "body": "Ihre erste Sitzung kostet nichts, und Sie brauchen keine Karte. Eine vergangene Sitzung können Sie jederzeit kostenlos wieder anhören. Wenn Sie mehr möchten, gibt es bezahlte Tarife.",
      "cta": "Jetzt beginnen"
    },
    "plans": {
      "heading": "Tarife",
      "body": "Wenn Sie öfter Sitzungen hören möchten, finden Sie hier die passenden bezahlten Tarife."
    }
  },
  "es": {
    "hero": {
      "title": "Una sesión de hipnosis escrita para ti, para cómo te sientes ahora",
      "line": "Quies es hipnosis con IA que puedes empezar ahora mismo. Elige cómo te sientes y una voz tranquila te la lee.",
      "cta": "Empezar una sesión"
    },
    "mailHeadline": "Tu sesión de hipnosis, escrita para hoy",
    "tags": {
      "listen": "Escuchar"
    },
    "written": {
      "title": "Escrita para este momento",
      "body": "Dinos cómo te sientes con unos toques o unas palabras. La sesión se escribe para ese momento y después te la leemos."
    },
    "listen": {
      "title": "Escucha una sesión",
      "body": "Estas son sesiones reales. Debajo del reproductor ves impresas las palabras que se dicen."
    },
    "tongues": {
      "title": "En tu idioma",
      "body": "Hay sesiones en otros idiomas, y puedes escucharlas aquí mismo. Elige la lengua que te resulte más cómoda."
    },
    "remembers": {
      "title": "Te recuerda",
      "body": "La siguiente sesión empieza donde terminó la anterior, sin que tengas que volver a explicarte.",
      "lines": [
        "Lo que te pesó en la última sesión.",
        "Cómo te sentiste al terminar.",
        "Lo que te ayudó a relajarte."
      ]
    },
    "methods": {
      "title": "Métodos de relajación",
      "body": "Cada sesión sigue una forma conocida de relajarse. Puedes elegir la que prefieras.",
      "items": {
        "ericksonian": {
          "label": "hipnosis ericksoniana",
          "desc": "Un estilo de hipnosis suave que usa imágenes y palabras sencillas para calmarte."
        },
        "autogenic": {
          "label": "entrenamiento autógeno",
          "desc": "Frases cortas sobre pesadez y calor que ayudan a aflojar el cuerpo."
        },
        "pmr": {
          "label": "relajación progresiva",
          "desc": "Tensar y soltar cada parte del cuerpo, poco a poco, hasta sentirlo suelto."
        },
        "nidra": {
          "label": "yoga nidra",
          "desc": "Un descanso guiado, tumbado, en el que el cuerpo se relaja sin dormirse del todo."
        },
        "nsdr": {
          "label": "NSDR (descanso profundo sin dormir)",
          "desc": "Una pausa guiada para descansar la mente en pocos minutos, sin necesidad de dormir."
        },
        "sophrology": {
          "label": "sofrología",
          "desc": "Respiración y movimientos suaves que te ayudan a sentirte más tranquilo y presente."
        }
      }
    },
    "closing": {
      "title": "Tu primera sesión es gratis",
      "body": "Tu primera sesión no cuesta nada y no necesitas tarjeta. Volver a escuchar una sesión pasada siempre es gratis. Hay planes de pago si quieres más.",
      "cta": "Empezar una sesión"
    },
    "plans": {
      "heading": "Planes",
      "body": "Si quieres más sesiones, existen planes de pago pensados para ti."
    }
  },
  "ja": {
    "hero": {
      "title": "今のあなたのために書かれる催眠セッション。",
      "line": "Quiesは、いまから始められるAI催眠です。今の気持ちを選ぶと、落ち着いた声でセッションを読み上げます。",
      "cta": "セッションを始める"
    },
    "mailHeadline": "あなたのセッションができました",
    "tags": {
      "listen": "聴く"
    },
    "written": {
      "title": "今この瞬間のために書かれる",
      "body": "いくつかタップするか、短い言葉で今の気持ちを伝えてください。そのときのためのセッションが書かれ、読み上げられます。"
    },
    "listen": {
      "title": "ひとつ聴いてみる",
      "body": "実際のセッションです。話されている言葉を、プレーヤーの下に載せています。"
    },
    "tongues": {
      "title": "いろいろな言語で",
      "body": "ほかの言語のセッションもあります。ここで再生できます。"
    },
    "remembers": {
      "title": "あなたを覚えています",
      "body": "次のセッションは、前回の続きから始まります。",
      "lines": [
        "前回の気持ち",
        "心地よかった言葉",
        "よく聴く時間帯"
      ]
    },
    "methods": {
      "title": "いろいろな方法から",
      "body": "催眠にはいくつかの流儀があります。",
      "items": {
        "ericksonian": {
          "label": "エリクソン催眠",
          "desc": "命令ではなく、やわらかな示唆と物語で導く方法です。"
        },
        "autogenic": {
          "label": "自律訓練法",
          "desc": "体の重さや温かさに意識を向けて、落ち着きを育てる方法です。"
        },
        "pmr": {
          "label": "漸進的筋弛緩法",
          "desc": "体の筋肉を順に緩めて、力みを手放す方法です。"
        },
        "nidra": {
          "label": "ヨガニードラ",
          "desc": "体を横たえたまま、体の感覚を順に意識していく方法です。"
        },
        "nsdr": {
          "label": "NSDR（眠らない深い休息）",
          "desc": "眠らずに、目を閉じて深く休む方法です。"
        },
        "sophrology": {
          "label": "ソフロロジー",
          "desc": "呼吸と体の動きを使って、穏やかな状態をつくる方法です。"
        }
      }
    },
    "closing": {
      "title": "最初のセッションは無料です",
      "body": "最初のセッションは無料で、カードの登録も要りません。過去のセッションは、いつでも無料で聴き直せます。有料プランもあり、もっと聴きたい方に向いています。",
      "cta": "セッションを始める"
    },
    "plans": {
      "heading": "有料プラン",
      "body": "もっと続けたい方のために、有料プランを用意しています。"
    },
    "meta": {
      "title": "今の気持ちに合わせたAI催眠セッション | Quies",
      "description": "今の気持ちに合わせて書かれるAI催眠セッションです。今の気持ちを数回タップするだけで、落ち着いた声のセッションを読み上げます。最初のセッションは無料で、お聴きになる前にログインしていただきます。",
      "ogTitle": "今の気持ちに合わせたAI催眠セッション",
      "ogDescription": "今の気持ちに合わせて書かれる催眠セッション。最初のセッションは無料です。"
    },
    "faq": {
      "heading": "よくある質問",
      "items": [
        {
          "question": "Quiesとは何ですか。",
          "answer": "Quiesは、今の気持ちに合わせた催眠セッションを書き、落ち着いた声で読み上げるサービスです。"
        },
        {
          "question": "エリクソン催眠とは何ですか。",
          "answer": "ミルトン・H・エリクソンが発展させた催眠の方法です。命令ではなく、やわらかな示唆や物語を使って導きます。"
        },
        {
          "question": "セッションはどのように進みますか。",
          "answer": "いくつかタップし、必要であれば短い言葉を添えます。そのあと、15分から20分ほどのセッションが書かれ、読み上げられます。"
        },
        {
          "question": "瞑想と同じものですか。",
          "answer": "同じではありません。瞑想は注意を整える練習で、催眠は集中した穏やかな状態へ導きます。"
        },
        {
          "question": "経験は必要ですか。",
          "answer": "必要ありません。そのまま始めて聴けます。"
        }
      ]
    },
    "structured": {
      "description": "今の気持ちに合わせて書かれる、AI催眠のセッションサービスです。",
      "offerDescription": "最初のセッションは無料です。お聴きになる前にログインしていただきます。",
      "featureList": [
        "今の気持ちに合わせて書かれるセッション",
        "落ち着いた声での読み上げ",
        "前回の続きから始まる次のセッション",
        "いろいろな言語のセッション",
        "過去のセッションを無料で聴き直せること"
      ],
      "keywords": "AI催眠, 催眠セッション, エリクソン催眠, 瞑想, リラックス, 睡眠, Quies"
    },
    "walkthrough": {
      "frameTitles": [
        "今の気持ちをタップ",
        "必要なら深く",
        "あなたのためのセッション"
      ],
      "descriptions": [
        "簡単なタップで、今いる場所を伝えます。",
        "選択と短い言葉で、もっと伝えられます。必要なときだけで構いません。",
        "伝えてくださったことをもとに、今の状態に合わせたセッションが書かれます。"
      ],
      "writingPrompt": "今、心に引っかかっていることはありますか。",
      "writingSample": "仕事が続いて、頭がずっと忙しくて...",
      "acknowledgement": "お話を受け取りました。セッションを書いています。",
      "shuffleHint": "しっくりこなかったですか。別の角度で試してみてください。"
    }
  },
  "zh": {
    "hero": {
      "title": "为此刻的你而写的催眠课程",
      "line": "Quies 是一款 AI催眠 工具，现在就可以开始一段课程。选择你此刻的感受，平静的声音会为你朗读整段课程。",
      "cta": "开始一段课程"
    },
    "mailHeadline": "你的课程已经准备好",
    "tags": {
      "listen": "收听"
    },
    "written": {
      "title": "为此刻而写",
      "body": "用几次点按或几句话，说说你现在的感受。课程为这一刻而写，写好后朗读给你听。"
    },
    "listen": {
      "title": "听一段真实的课程",
      "body": "每段课程都有真实的朗读。播放器下方印着朗读的文字，你可以边听边看。"
    },
    "tongues": {
      "title": "用你的语言",
      "body": "课程也有其他语言的版本，可以直接在这里播放。"
    },
    "remembers": {
      "title": "它记得你",
      "body": "下一段课程会从上一段结束的地方接着开始。",
      "lines": [
        "你最近的心情",
        "你想放松的地方",
        "你上一段课程的内容"
      ]
    },
    "methods": {
      "title": "几种放松的方法",
      "body": "课程借助以下几种成熟的放松方法引导你，你无需事先了解它们。",
      "items": {
        "ericksonian": {
          "label": "艾瑞克森催眠",
          "desc": "用间接的暗示和故事引导你，而不是直接下命令。"
        },
        "autogenic": {
          "label": "自律训练",
          "desc": "通过想象身体变得沉重和温暖，帮助身体慢慢松弛下来。"
        },
        "pmr": {
          "label": "渐进式肌肉放松",
          "desc": "依次绷紧再放松身体的各个部位，让肌肉逐渐松开。"
        },
        "nidra": {
          "label": "瑜伽睡眠 (Yoga Nidra)",
          "desc": "躺下来，跟随声音扫过身体的各个部位，进入深度的放松。"
        },
        "nsdr": {
          "label": "NSDR（非睡眠深度休息）",
          "desc": "一种不需要入睡的深度休息方式，让大脑和身体安静下来。"
        },
        "sophrology": {
          "label": "索福罗学（Sophrology）",
          "desc": "结合呼吸、放松和专注的练习，帮助你平静下来。"
        }
      }
    },
    "closing": {
      "title": "第一段课程免费",
      "body": "第一段课程不收费，也不需要绑定银行卡。再次收听以前的课程始终免费。如果你想要更多，可以选择付费方案。",
      "cta": "开始一段课程"
    },
    "plans": {
      "heading": "付费方案",
      "body": "如果你想听更多课程，我们提供付费方案。"
    },
    "meta": {
      "title": "为此刻而写的AI催眠课程 | Quies",
      "description": "AI催眠工具。根据你此刻的感受，为你写一段催眠课程，用平静的声音朗读给你听。第一段课程免费，收听前需先登录。",
      "ogTitle": "为此刻的你而写的AI催眠课程",
      "ogDescription": "用几次点按说说你的感受，Quies 为你写一段催眠课程，用平静的声音朗读给你听。"
    },
    "faq": {
      "heading": "常见问题",
      "items": [
        {
          "question": "Quies 是什么？",
          "answer": "Quies 是一款 AI催眠 服务。它根据你此刻的感受写一段课程，并用平静的声音朗读给你听。"
        },
        {
          "question": "什么是艾瑞克森催眠？",
          "answer": "艾瑞克森催眠是一种催眠风格，由米尔顿·H·埃里克森（Milton H. Erickson）发展而来。它不直接下命令，而是用间接的暗示和故事来引导你。"
        },
        {
          "question": "课程是怎么进行的？",
          "answer": "你用几次点按选择此刻的感受，也可以写几句话。随后会为你写一段约15到20分钟的课程，并朗读给你听。"
        },
        {
          "question": "这和冥想一样吗？",
          "answer": "不一样。冥想主要训练注意力，催眠则引导你进入专注而平静的状态。"
        },
        {
          "question": "我需要有经验吗？",
          "answer": "不需要。找一个安静的地方，舒服地坐下或躺下，跟随声音听就可以了。"
        }
      ]
    },
    "structured": {
      "description": "Quies 是一款 AI催眠 工具，根据你此刻的感受写一段课程，并用平静的声音朗读给你听。",
      "offerDescription": "第一次课程免费，收听之前需要先登录。",
      "featureList": [
        "根据你此刻的感受写课程",
        "平静的声音朗读",
        "下一段课程接着上一段",
        "支持多种语言",
        "第一段课程免费"
      ],
      "keywords": "AI催眠, 催眠课程, 放松课程, 艾瑞克森催眠, 平静, 睡前放松"
    },
    "walkthrough": {
      "frameTitles": [
        "此刻的感受",
        "想再深入一点",
        "为此刻而写"
      ],
      "descriptions": [
        "轻点一下，告诉我们你现在的感受。",
        "如果你愿意，再选择一个方向，并写下几句话。",
        "你分享的所有内容，都会变成适合你此刻状态的课程。"
      ],
      "writingPrompt": "你现在有什么放不下的事吗？",
      "writingSample": "最近工作很多，晚上躺下还是停不下来……",
      "acknowledgement": "我听到了。课程正在为你写作。",
      "shuffleHint": "没有共鸣？换个角度试试。"
    }
  }
}
